const TRANSITION_DURATION = 300
const TRUNCATION_TOLERANCE = 4
const REVEAL_THRESHOLD = 0.2

class AnniversaryStoryItem extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupReveal()

    if (!this.els.trigger?.exists) return

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onTransitionEnd = this.onTransitionEnd.bind(this)
    this.updateTriggerVisibility = window.BAO.Utils.debounce(
      this.updateTriggerVisibility.bind(this),
      100,
    )

    this.listeners.add(this.els.trigger.element, 'click', this.onTriggerClick)
    this.listeners.add(window, 'resize', this.updateTriggerVisibility)

    this.updateTriggerVisibility()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.revealObserver?.disconnect()
  }

  setupReveal () {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches
    if (prefersReducedMotion) return

    this.revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          this.classList.add('util-InView')
          this.revealObserver.unobserve(this)
        })
      },
      { threshold: REVEAL_THRESHOLD },
    )

    this.revealObserver.observe(this)
  }

  updateTriggerVisibility () {
    if (this.classList.contains('sec-AnniversaryStory_Item-expanded')) return

    const textEl = this.els.text?.element
    if (!textEl) return

    this.els.trigger.element.hidden =
      textEl.scrollHeight <= textEl.clientHeight + TRUNCATION_TOLERANCE
  }

  onTriggerClick () {
    this.setExpanded(
      !this.classList.contains('sec-AnniversaryStory_Item-expanded'),
    )
  }

  setExpanded (expanded) {
    this.els.trigger.element.setAttribute('aria-expanded', String(expanded))

    const textEl = this.els.text?.element
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches

    if (!textEl || prefersReducedMotion) {
      this.classList.toggle('sec-AnniversaryStory_Item-expanded', expanded)
      return
    }

    textEl.style.transition = 'none'
    textEl.style.removeProperty('max-block-size')
    textEl.style.removeProperty('overflow')

    const startHeight = textEl.getBoundingClientRect().height

    this.classList.toggle('sec-AnniversaryStory_Item-expanded', expanded)

    const endHeight = textEl.getBoundingClientRect().height

    if (startHeight === endHeight) return

    textEl.style.overflow = 'hidden'
    textEl.style.maxBlockSize = `${startHeight}px`

    textEl.getBoundingClientRect()

    textEl.style.transition = `max-block-size ${TRANSITION_DURATION}ms ease`
    textEl.style.maxBlockSize = `${endHeight}px`

    textEl.addEventListener('transitionend', this.onTransitionEnd, {
      once: true,
    })
  }

  onTransitionEnd (event) {
    const textEl = this.els.text?.element
    if (event.target !== textEl) return

    textEl.style.removeProperty('transition')
    textEl.style.removeProperty('max-block-size')
    textEl.style.removeProperty('overflow')
  }
}

if (!customElements.get('anniversary-story-item')) {
  customElements.define('anniversary-story-item', AnniversaryStoryItem)
}
